import { AppLogo } from '@/components/shared/AppLogo';

interface AuthHeaderProps {
  title: string;
  subtitle: string;
}

export function AuthHeader({ title, subtitle }: AuthHeaderProps) {
  return (
    <div className="flex flex-col items-center space-y-4 mb-8">
      {/* Logo/Brand Mark */}
      <div className="flex items-center gap-3">
        <AppLogo variant="icon" size="lg" />
        <span className="text-2xl font-semibold text-foreground">modcar</span>
      </div>

      {/* Title and Subtitle */}
      <div className="text-center space-y-2">
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      </div>
    </div>
  );
}
